<template>
  <div class="page-wrapper">
    <h1>Токены</h1>
    <tokens-list/>
  </div>
</template>

<script>
  import TokensList from '@/TokensList';
  
  export default {
    name: 'UserTokensView',
    components: {
      TokensList
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/UserTokensView.vue